export default {
  date: 'March 12, 2025',
  title: 'New Update: High Speed, Ultra High Quality, and Style Selection Inside a Single Widget',
  description: 'A powerful tool to sell properties faster and more effectively',
  id: 'new-update',
  jsx: () => (
    <div class='novelty__text'>
      <p>
        <b>What’s New?</b>
      </p>
      <p>
        <b>3x Faster Loading Speed</b>
      </p>
      <p>
        Your tours will now load <b>3 times faster</b>, providing a smoother and more enjoyable experience.
      </p>
      <p>
        <b>Multiple Styles in One Tour</b>
      </p>
      <p>
        Now, you can explore <b>3 different styles</b> for the same property with a single click. Simply use the selection button to switch between styles effortlessly.
      </p>
      <p>
        <b>Ultra High-Quality 4K Resolution</b>
      </p>
      <p>
        For <b>Max Set</b> users, we've upgraded the quality to <b>Ultra High (4K resolution)</b>, delivering even more photorealistic visuals.
      </p>
      <p>
        <b>Dual-Link Access for a Smooth Transition</b>
      </p>
      <p>For the next two months, you’ll receive both the previous and new versions of the tour. This way, you can switch between them and adapt seamlessly to the update.</p>
      <p>
        <b>Faster Sales and a Better Buying Experience</b>
      </p>
      <p>
        <b style='color: #FFA900'>For Sellers:</b>
      </p>
      <p>A high-speed, high-quality virtual tour means faster decision-making from potential buyers. With enhanced photorealism and multiple styles available in one tour, properties can be showcased more effectively, increasing engagement and leading to quicker sales.</p>
      <p>
        <b style='color: #FFA900'>For Buyers:</b>
      </p>
      <p>A detailed and immersive virtual tour allows buyers to explore a property in different styles, helping them visualize potential renovations or furniture placements. This makes decision-making easier and more confident, reducing the need for multiple physical visits.</p>
      <p>Experience the future of virtual tours today.</p>
    </div>
  ),
  thumb: 'news/42.webp',
};
